import parserUtils from './utils'
import { toNumber, get, deburr, toLower } from 'lodash'
import { Behavioral } from '@node/wam-audience-builder'

export default {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: state => {
        const taxonomiesRoute = '/audience_admin/bigsea_taxonomies.json'
        const segmentsRoute = '/audience_admin/bigsea_segments.json'
        const clusterRoute = '/audience_admin/bigsea_taxonomies/bigsea_clusters/json'
        const params = { params: { list_limit: 0 } }
        const clusterParams = { params: { account_id: state.accountId } }
        return {
            taxonomiesRoute,
            segmentsRoute,
            clusterRoute,
            params,
            clusterParams
        }
    },

    parseData: (type, data, countryCode2) => {
        const _data = []
        for (const val of data) {
            let wamData = {
                id: type === 'taxonomy' ? val.owner + '_' + val.taxonomy : toNumber(val.id),
                label: type === 'cluster' ? val.cluster : val.label,
                isSelectable: type === 'taxonomy' ? false : true,
                hasChild: type === 'segment' || type === 'taxonomy' ? true : false,
                parentJsonKeyName: parserUtils.getParentJsonKeyName(type, val),
                smartSegmentIds: parserUtils.getSmartSegmentIds(get(val, 'smart_segments', null)),
                jsonKey: parserUtils.buildJsonKey(type, val, countryCode2)
            }
            if (type === 'taxonomy') {
                wamData = {
                    ...wamData,
                    display_order: toNumber(val.taxonomy_order)
                }
                _data.push(wamData)
                _data.sort((a, b) => (a.display_order > b.display_order ? 1 : b.display_order > a.display_order ? -1 : 0))
            } else {
                _data.push(wamData)
                _data.sort((a, b) => (toLower(deburr(a.label)) > toLower(deburr(b.label)) ? 1 : toLower(deburr(b.label)) > toLower(deburr(a.label)) ? -1 : 0))
            }
        }
        return _data
    },

    instanciateAll: (segments, countryCode) => {
        const generaTaxoId = segments.find(segment => segment.taxonomy === 'gt' && segment.owner === 'wb')?.id

        return Behavioral.createAll(
            segments.map(segment => {
                const parentCategory = 'Behavioral'
                let parentSubCategory = 'Taxonomy'
                let parentId = generaTaxoId

                if (segment.type === 'Cluster') {
                    if (segment.bigsea_segment_id != undefined) {
                        parentSubCategory = 'Segment'
                        parentId = segment.bigsea_segment_id
                    } else {
                        parentId = segments.find(taxo => taxo.taxonomy === segment.taxonomy && taxo.owner === segment.owner)?.id
                    }
                }

                return {
                    id: parseInt(segment.id),
                    label: segment.type === 'Cluster' ? segment.cluster : segment.label,
                    path: ['Third Party', 'Behavioral'],
                    parentId:
                        segment.type === 'Taxonomy'
                            ? null
                            : Behavioral.generateCrossId({
                                category: parentCategory,
                                subCategory: parentSubCategory,
                                id: parentId
                            }),
                    selectable: segment.type === 'Taxonomy' ? false : true,
                    subCategory: segment.type,
                    countryCode
                }
            })
        )
    }
}
